import { render, staticRenderFns } from "./AppMenuItem.vue?vue&type=template&id=5a8b66c3&"
import script from "./AppMenuItem.vue?vue&type=script&lang=js&"
export * from "./AppMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports